import React, { useContext } from 'react';
import { LocaleContext } from './LocaleContext';

export const useLocalize = () => {
  const { locale } = useContext(LocaleContext);
  return React.useMemo(
    () => ({
      locale,
    }),
    [locale],
  );
};
